var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_c('span',[_vm._v("База знаний")])]),_c('section',[_c('div',{staticClass:"files-library knowledge-base"},[_c('router-view',{attrs:{"container-id":0,"nav-parent":"/knowledge/files"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }